var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscountWarrantyclaim({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3780_6620)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5 0C36.4789 0 47 10.5211 47 23.5C47 36.4789 36.4789 47 23.5 47C10.5211 47 0 36.4789 0 23.5C0 10.5211 10.5211 0 23.5 0ZM13.1032 24.1252C13.4185 22.2971 15.5051 21.2793 17.1516 22.2697C17.3009 22.3588 17.4434 22.4645 17.576 22.5859L17.5888 22.5982C18.3276 23.3061 19.1554 24.0429 19.976 24.7734L20.68 25.4055L29.0338 16.6429C29.5326 16.1205 29.8974 15.7827 30.646 15.6143C33.2089 15.0488 35.0111 18.1817 33.1947 20.0964L22.7833 31.0229C21.8026 32.0692 20.0499 32.1646 18.9958 31.1654C18.3917 30.6043 17.7347 30.0335 17.0703 29.4573C15.9198 28.4575 14.7463 27.4377 13.7896 26.4282C13.2153 25.8544 12.9676 24.9149 13.1032 24.1252Z",
    fill: "#6BBE66"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3780_6620"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 47,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscountWarrantyclaim);
export default __webpack_public_path__ + "static/media/Discount-warrantyclaim.6903c402ffc26a1df73841300f602c0c.svg";
export { ForwardRef as ReactComponent };